module.exports = __webpack_public_path__ + "img/ping1.e3b2a699.png";